import Box from "@mui/material/Box";

import { useDispatch, useSelector } from "react-redux";

import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { actionPhotoDownloadRoomsWithPhotos } from "./PhotoRedux";

const checkboxLabelRoot_ = (theme) => ({
  marginLeft: "-7px",
});

const checkboxLabel_ = (theme) => ({
  fontSize: "0.9rem",
});

const checkbox_ = (theme) => ({
  padding: "5px",
  "& svg": {
    fontSize: "1.25rem",
  },
});

export default function RoomInfo({
  targetRoom,
  checked,
  onCheckboxChange,
  busy,
}) {
  const { rmnbr, bldrecnbr, bld_descrshort } = targetRoom || {};

  return (
    <Box>
      <Box>Building: {bld_descrshort}</Box>
      <Box>Room: {rmnbr} </Box>
      <Box>
        <HighlightRoomCheckbox
          checked={checked}
          onChange={onCheckboxChange}
          busy={busy}
          bldrecnbr={bldrecnbr}
          bld_descrshort={bld_descrshort}
        />
      </Box>
    </Box>
  );
}

function HighlightRoomCheckbox({
  checked,
  onChange,
  busy,
  bldrecnbr,
  bld_descrshort,
}) {
  const dispatch = useDispatch();
  const rooms = useSelector((state) => state.photoReducer.targetBuildingPhotos);
  const validRoom = checked && rooms !== "fetching" && rooms !== null;
  const roomCount = validRoom ? formatRoomCount(rooms) : "";

  const downloadRooms = () => {
    dispatch(actionPhotoDownloadRoomsWithPhotos(rooms, bldrecnbr));
  };

  return (
    <span>
      <FormControlLabel
        control={
          rooms !== "fetching" ? (
            <Checkbox
              checked={checked}
              onChange={onChange}
              name="highlight-rooms-with-photo"
              color="primary"
              sx={checkbox_}
            />
          ) : (
            <CircularProgress
              style={{ width: 26, height: 26, margin: "2px" }}
            />
          )
        }
        disabled={busy || rooms === "fetching"}
        label={
          <span>
            Mark all rooms in {bld_descrshort} with available photos
            <DownloadButton
              isVisible={rooms && rooms !== "fetching"}
              onClick={downloadRooms}
              text={roomCount}
              isDisabled={!rooms || (rooms && rooms.length < 1)}
              noPhotoAvailable={
                checked &&
                rooms !== null &&
                rooms !== "fetching" &&
                rooms.length === 0
              }
            />
          </span>
        }
        sx={checkboxLabelRoot_}
        slotProps={{
          typography: {
            sx: checkboxLabel_,
          },
        }}
      />
    </span>
  );
}

function DownloadButton({
  isVisible,
  onClick,
  text,
  isDisabled,
  noPhotoAvailable,
}) {
  return (
    <span>
      {isVisible && !noPhotoAvailable && (
        <Button
          style={{ color: "rgb(0, 100, 177)", padding: "2px 8px" }}
          onClick={onClick}
          disabled={isDisabled}
          title="Download"
        >
          {text}
        </Button>
      )}
      {noPhotoAvailable && (
        <span>
          {" "}
          (<span style={{ color: "red" }}>No Photo Available</span>)
        </span>
      )}
    </span>
  );
}

function formatRoomCount(rooms) {
  return rooms.length === 1 ? "(1 Room)" : `(${rooms.length} Rooms)`;
}
